// The name of a Network is used to group networks in the front-end Integrations list page.
// See https://git.datacandy.com/nicejob/microservices/tree/master/appengine-routes/frontend-route/src/pages/Settings/Product/Integrations/ChildComponents/common/utils.ts#L68
export enum NetworkName {
    ACCULYNX = 'acculynx',
    BBB = 'bbb',
    CAPTERRA = 'capterra',
    CITYSEARCH = 'citysearch',
    CLIO = 'clio',
    COMPANYCAM = 'companycam',
    CONVERT_LABS = 'convert_labs',
    DATACANDY = 'datacandy',
    DRCHRONO = 'drchrono',
    FACEBOOK = 'facebook',
    FACEBOOK_DEV = 'facebook_dev', // Used on outbound-oauth facebook strategy for when a dev account is needed (networks/facebook/strategy.ts)
    FIELDPULSE = 'fieldpulse',
    FRESHBOOKS = 'freshbooks',
    G2 = 'g2',
    GOOGLE = 'google',
    GOOGLE_ANALYTICS = 'google-analytics',
    GOOGLE_RSV = 'google-rsv',
    HOMEADVISOR = 'homeadvisor',
    HOMESTARS = 'homestars',
    HOUSECALLPRO = 'housecallpro',
    HUBSPOT = 'hubspot',
    INSTAGRAM = 'instagram',
    INTERCOM = 'intercom',
    JOBBER = 'jobber',
    JOB_TREAD = 'job_tread',
    LIBRO = 'libro',
    LINKEDIN = 'linkedin',
    MARKATE = 'markate',
    MINDBODY = 'mindbody',
    NICEJOB = 'nicejob',
    PAYPAL = 'paypal',
    QDS = 'qds',
    QUICKBOOKS = 'quickbooks',
    RESPONSIBID = 'responsibid',
    SENDJIM = 'sendjim',
    SERVICEMONSTER = 'servicemonster',
    SERVICETITAN = 'servicetitan',
    SERVICE_WHALE = 'service_whale',
    SQUARE = 'square',
    STRIPE = 'stripe',
    THESEAL = 'theseal',
    TRIPADVISOR = 'tripadvisor',
    TWITTER = 'twitter',
    UEAT = 'ueat',
    VONIGO = 'vonigo',
    XERO = 'xero',
    YELP = 'yelp',
    YP = 'yp',
    ZAPIER = 'zapier',
    ZENDESK = 'zendesk',
    ZILLOW = 'zillow',
}
